import { assign } from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IVendorAdditionalInfo extends IModel {
	name?: string;
	value?: string;
}

const vendorAdditionalInfoFactory = modelFactory.createFactory('VendorAdditionalInfo', assign({}, model, {
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	}
}));

export default vendorAdditionalInfoFactory;